import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import type { TaskReportResponse } from '../../../api/types';
import { useAuth } from '../../../app/providers/useAuth';
import { fetchReport } from '../api/reportsApi';

const REPORT_PERIOD_DAYS = 7; // PARA-105, AC-4: период по умолчанию — последние 7 дней

function toIsoDate(date: Date): string {
  return date.toISOString().slice(0, 10);
}

export function defaultReportRange(now: Date = new Date()): { from: string; to: string } {
  const from = new Date(now);
  from.setDate(from.getDate() - REPORT_PERIOD_DAYS);
  return { from: toIsoDate(from), to: toIsoDate(now) };
}

export function useReports(): UseQueryResult<TaskReportResponse> {
  const { user } = useAuth();
  const { from, to } = defaultReportRange();

  return useQuery({
    queryKey: ['reports', user?.id, from, to],
    queryFn: () => fetchReport(from, to),
    enabled: user !== null,
  });
}
